// extracted by mini-css-extract-plugin
export default {"primaryText":"HowWeDevelop_primaryText__jwnZ5","circleArrow":"HowWeDevelop_circleArrow__2Urcm"};